import { render, staticRenderFns } from "./PrivilegeImage.vue?vue&type=template&id=82cab4b4&"
import script from "./PrivilegeImage.vue?vue&type=script&lang=js&"
export * from "./PrivilegeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports